import { render, staticRenderFns } from "./shop-cart.vue?vue&type=template&id=3fe3d06a&scoped=true"
import script from "./shop-cart.vue?vue&type=script&lang=js"
export * from "./shop-cart.vue?vue&type=script&lang=js"
import style0 from "./shop-cart.vue?vue&type=style&index=0&id=3fe3d06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe3d06a",
  null
  
)

export default component.exports